import WishlistHeart from './WishlistHeart.jsx';

export default WishlistHeart;



// WEBPACK FOOTER //
// ./src/pages/Search/Main/CardSlider/CardContainer/Card/WishlistHeart/index.js